import { useReducer } from 'react'

const initialState = {
  encrypt: '',
  decrypt: '',
  encryptError: false,
  decryptError: false,
}

const reducer = (
  state: typeof initialState,
  action:
    | { type: 'SET_ENCRYPT_VALUE'; payload: { encrypt: string } }
    | { type: 'SET_ENCRYPT_RESULT'; payload: { decrypt: string } }
    | { type: 'SET_DECRYPT_VALUE'; payload: { decrypt: string } }
    | { type: 'SET_DECRYPT_RESULT'; payload: { encrypt: string } }
    | { type: 'SET_DECRYPT_ERROR' },
) => {
  switch (action.type) {
    case 'SET_ENCRYPT_VALUE':
      return {
        ...state,
        encrypt: action.payload.encrypt,
        decryptError: false,
        encryptError: false,
      }
    case 'SET_ENCRYPT_RESULT':
      return {
        ...state,
        decrypt: state.encrypt ? action.payload.decrypt : '',
      }
    case 'SET_DECRYPT_VALUE':
      return {
        ...state,
        decrypt: action.payload.decrypt,
        decryptError: false,
        encryptError: false,
      }
    case 'SET_DECRYPT_RESULT':
      return {
        ...state,
        encrypt: state.decrypt ? action.payload.encrypt : '',
      }
    case 'SET_DECRYPT_ERROR':
      return { ...state, decryptError: true, encryptError: false, encrypt: '' }
    default:
      return state
  }
}

export function useCryptoReducer() {
  return useReducer(reducer, initialState)
}
